export default class MobileMenu {
    constructor(context) {
        this.context = context;

        // Константы
        this.OPEN_CLASS = 'h-open';
        this.MENU_WIDTH = 420;
        this.INNER_MENU_OFFSET = 20;
        this.INNER_LINK_CLASS = 'l-dropdown__menu-link';
        this.INNER_LIST_CLASS = 'l-dropdown__menu-list';

        // Состояния открытия и вложенности
        this.opened = false;
        this.innered = false;

        // Выбираем элементы
        this.triggers = [].slice.call(document.querySelectorAll('.js-mobile-menu'));
        this.closeTrigger = this.context.querySelector('.js-close');
        this.innerTriggers = [].slice.call(this.context.querySelectorAll('.js-inner'));
        this.backTriggers = [].slice.call(this.context.querySelectorAll('.js-back'));

        this.initAccordionMenus();

        this.bindClickEvents();
    }

    static appendInnerMenuIcon(elem) {
        const icon = document.createElement('span');

        icon.className = 'g-icon__toggle--list';
        elem.appendChild(icon);

        return icon;
    }

    static initSingleAccordion(link, list) {
        const icon = MobileMenu.appendInnerMenuIcon(link);

        icon.addEventListener('click', (e) => {
            list.classList.toggle('is-visible');
            icon.classList.toggle('is-toggled');

            e.preventDefault();
            e.stopPropagation();
        });
    }

    // Добавляет иконки во внутренние меню и возможность скрытия/раскрытия
    initAccordionMenus() {
        const innerLinks = this.context.querySelectorAll(`.${this.INNER_LINK_CLASS}`);

        [].forEach.call(innerLinks, (elem) => {
            const possibleList = elem.nextElementSibling;

            if (possibleList && possibleList.classList.contains(this.INNER_LIST_CLASS)) {
                MobileMenu.initSingleAccordion(elem, possibleList);
            }
        });
    }

    // Привязка функций класса к кликам
    bindClickEvents() {
        // клик по гамбургеру
        this.triggers.forEach((elem) => {
            elem.addEventListener('click', this.openMenu.bind(this));
        });

        // клик по крестику
        this.closeTrigger.addEventListener('click', this.closeMenu.bind(this));

        // клик по пункту из первичного меню
        this.innerTriggers.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                this.openInner(elem);
                e.preventDefault();
            });
        });

        // клик "назад" из вложенного меню
        this.backTriggers.forEach((elem) => {
            elem.addEventListener('click', this.closeInner.bind(this));
        });

        window.addEventListener('click', (e) => {
            if (this.opened) {
                if (e.pageX > this.MENU_WIDTH) {
                    // клик по тёмному полю справа от меню
                    this.closeMenu();
                    if (this.innered) {
                        this.closeInner();
                    }
                } else if (e.pageX < this.INNER_MENU_OFFSET && this.innered) {
                    // клик по тёмному полю слева от вложенного меню
                    this.closeInner();
                }
            }
        });
    }

    // Открытие основного меню
    openMenu() {
        this.opened = true;
        this.context.classList.add(this.OPEN_CLASS);
    }

    // Закрытие основного меню
    closeMenu() {
        this.opened = false;
        this.context.classList.remove(this.OPEN_CLASS);
    }

    // Открытие вложенного меню
    openInner(trigger) {
        this.innered = true;
        trigger.parentNode.classList.add(this.OPEN_CLASS);
    }

    // Закрытие вложенного меню
    closeInner() {
        this.innered = false;
        this.context.querySelector(`.${this.OPEN_CLASS}`).classList.remove(this.OPEN_CLASS);
    }
}
